const PRINT_STORAGE_KEY = 'sampleRegisterPrintData';

export const formatRegisterQty = (qty) => {
  if (qty === null || qty === undefined || qty === '') return '';
  return String(qty).padStart(2, '0');
};

export const buildGroupedRegisterRows = (records) => {
  const rows = [];
  let prevRegisterId = null;

  records.forEach((record) => {
    const registerId = record.register_id;
    if (prevRegisterId !== null && registerId !== prevRegisterId) {
      rows.push({ type: 'separator', key: `sep-${prevRegisterId}-${registerId}` });
    }
    rows.push({
      type: 'data',
      key: record.line_id,
      record,
      isFirstInGroup: registerId !== prevRegisterId
    });
    prevRegisterId = registerId;
  });

  return rows;
};

const formatPrintDate = () => {
  const d = new Date();
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  const hours = String(d.getHours()).padStart(2, '0');
  const mins = String(d.getMinutes()).padStart(2, '0');
  return `${day}/${month}/${year} ${hours}:${mins}`;
};

const toDisplayDate = (isoDate) => {
  if (!isoDate) return '';
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(isoDate)) return isoDate;
  const parts = isoDate.split('-');
  if (parts.length === 3 && parts[0].length === 4) {
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
  }
  return isoDate;
};

export const buildRegisterFilterSummary = ({ searchQuery, fromDate, toDate, dateField, dateFieldLabels }) => {
  const parts = [];
  if (searchQuery?.trim()) {
    parts.push(`Search: "${searchQuery.trim()}"`);
  }
  if (fromDate || toDate) {
    const label = dateFieldLabels?.[dateField] || dateField;
    const from = toDisplayDate(fromDate) || '—';
    const to = toDisplayDate(toDate) || '—';
    parts.push(`${label}: ${from} to ${to}`);
  }
  return parts.length ? parts.join('  |  ') : 'All visible records';
};

const cell = (value) => {
  if (value === null || value === undefined || value === '') return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
};

export const openSampleRegisterPrint = ({ records, filterSummary }) => {
  if (!records?.length) {
    return false;
  }

  const grouped = buildGroupedRegisterRows(records);
  const printRows = grouped.map((row) => {
    if (row.type === 'separator') {
      return { type: 'separator' };
    }
    const { record, isFirstInGroup } = row;
    const parent = (val) => (isFirstInGroup ? cell(val) : '');
    return {
      type: 'data',
      cells: [
        parent(record.sample_received_date || ''),
        cell(record.ulr_number || ''),
        cell(record.sample_test_job_number || ''),
        parent(record.customer_name || ''),
        parent(record.site_name || ''),
        parent(record.sample_type || ''),
        parent(record.location_and_grade || ''),
        parent(record.test_requirement || ''),
        cell(formatRegisterQty(record.quantity)),
        cell(record.age_of_cube ?? ''),
        cell(record.grade_of_concrete || ''),
        cell(record.casting_date || ''),
        cell(record.test_in_set ?? ''),
        cell(record.testing_date || ''),
        cell(record.report_date || ''),
        cell(record.disposal_date || ''),
        cell(record.remarks || '')
      ]
    };
  });

  const payload = {
    title: 'Sample Test Record Register',
    subtitle: 'Construction Material Testing Laboratory',
    filterSummary: filterSummary || 'All visible records',
    printDate: formatPrintDate(),
    rowCount: records.length,
    rows: printRows
  };

  try {
    localStorage.setItem(PRINT_STORAGE_KEY, JSON.stringify(payload));
    window.open('/SampleTestRecordRegisterPrint.html', '_blank', 'noopener,noreferrer');
    return true;
  } catch (err) {
    console.error('Print failed:', err);
    return false;
  }
};
